module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HomeBanner', {
    staticClass: "_mgbt-32px _mgbt-64px-sm"
  }), _vm._v(" "), _c('HomeBenefits', {
    staticClass: "_mgbt-64px"
  }), _vm._v(" "), _c('HomeGettingStart')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d82fa1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/home/Home.vue
// module id = 124
// module chunks = 0